import React from "react"
import { EditorToolbarGroup, EditorToolbarItem } from "components/CanvasEditor/Toolbar/EditorToolbar"
import BADGE_ELEMENT_TYPES from "./elementTypes"
import { useBadgeElement } from "./contexts/BadgeElementContext"
import { ElementsIcon, ShapesIcon } from "./Icons"

const GROUPS = {
  shapes: {
    label: "Shapes",
    icon: <ShapesIcon width={24} height={24} strokeWidth={1.5} />,
    collapseBreakpoint: "xl",
  },
  elements: {
    label: "Elements",
    icon: <ElementsIcon width={24} height={24} strokeWidth={0.75} />,
    collapseBreakpoint: "lg",
  },
} as const

/** Toolbar group adding element types: click adds at the top-left, or drag onto the badge. */
const BadgeAddElements = ({ group }: { group: keyof typeof GROUPS }) => {
  const { handleAddElement } = useBadgeElement()
  const { label, icon, collapseBreakpoint } = GROUPS[group]

  return (
    <EditorToolbarGroup label={label} icon={icon} collapseBreakpoint={collapseBreakpoint}>
      {BADGE_ELEMENT_TYPES
        .filter((definition) => definition.group === group)
        .map((definition) => (
          <EditorToolbarItem
            key={definition.type}
            label={definition.name}
            icon={definition.icon}
            onClick={() => handleAddElement(definition.type, 0, 0)}
            drag={{ type: "TOOLBAR_ELEMENT", item: { elementType: definition.type } }}
            tooltip={`Drag or click to add ${definition.name}`}
          />
        ))}
    </EditorToolbarGroup>
  )
}

export default BadgeAddElements
